import { Outlet, useParams } from "react-router-dom";
import NavigationBar from "../Navigation";
import Messages from "../Messages";
import { useEffect } from "react";
import slugToTitle from "../../utils/slugToTitle";
import Cart from "../Cart";

const Root = () => {
  const { slug } = useParams();

  useEffect(() => {
    document.title = `Multifeiras - ${slugToTitle(slug)}`;
  }, [slug]);

  return (
    <div>
      <NavigationBar />
      <Messages />
      <Outlet />
      <Cart />
    </div>
  );
};

export default Root;
